var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{directives:[{name:"translate",rawName:"v-translate",value:({refereeName: _vm.props.refereeName, index: _vm.props.index}),expression:"{refereeName: props.refereeName, index: props.index}"}]},[_vm._v("\n  %{ refereeName }'s application %{ index }\n")])}
var staticRenderFns = []

export { render, staticRenderFns }